import Providers from '@m/providers';

import Request from './Request';
import { GlobalStyles } from './RequestApp.styled';

export default function RequestApp() {
  return (
    <Providers>
      <Request />
      <GlobalStyles />
    </Providers>
  );
}
